import React from "react";

import { useAuthContext } from "../../../auth";
import { useHeaderMenu } from "../../../hooks/use-header-menu";
import { Button } from "../../buttons/button";

export function SignupButton() {
  const { labels } = useHeaderMenu();
  const { login, checking } = useAuthContext();

  return (
    <Button
      variant="primary-outline"
      disabled={checking}
      className="w-fit"
      onClick={() => login?.({ register: true })}
    >
      {labels["header-menu-personal-area-signup-cta"]}
    </Button>
  );
}
